import React, { useState, useEffect } from 'react';

import PropTypes from 'prop-types';
import {useDispatch, useSelector} from "react-redux";
import {useTranslation} from "react-i18next";

import ReCAPTCHA  from "react-google-recaptcha";
import validate from "validate.js";
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/material.css'

import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Alert from "@material-ui/lab/Alert";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Link from "@material-ui/core/Link";
import FormHelperText from "@material-ui/core/FormHelperText";

import '../../assets/scss/onboarding-step1.css'
import { registerAccount, validatePhone, validateEmail } from "../../redux/actions/actionRegister";
import { useLocation } from "react-router-dom";
import { processUrl } from "../../services/utils";
import useGaTracker from '../../common/components/ga/useGaTracker'
import useGa4Tracker from '../../common/components/ga/useGa4Tracker'

export const keyCaptcha = process.env.REACT_APP_CAPTCHA;

const useStyles = makeStyles(theme => ({
 field: {
  margin: '10px 0',
 },
 paper: {
  marginTop: '10px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start'
 },
 paper2: {
  marginTop: '10px',
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: '#fffffff2',
  width:'60%',
  padding: '0 5% 0 5%',
  borderRadius: '20px',
  minWidth: '315px',
  maxWidth: '570px'
 },
 avatar: {
  margin: '1px',
 },
 form: {
  width: '90%',
  display: 'flex',
  flexDirection: 'column',
  maxWidth: '500px',
  minWidth: '280px'
  },
 submit: {
  display: 'flex',
  margin: '20px 0px 20px 0px',
  width: '200px',
  background: '#a5166c'
  },
 headerContainer: {
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  textAlign: "center",
  marginTop: "18px"
  },
 logo: {
  height: "60px"
 },
 info: {
  marginTop: "20px",
  fontSize: "15px"
  },
 error: {
  color: "red"
 },
 selectPlaceholder: {
  color: "#b5acac"
    }
}));

export const OnboardingStep1 = props => {
 const { history } = props;

 const queryParam = new URLSearchParams(useLocation().search);

 const classes = useStyles();

 const dispatch = useDispatch()

 const [t, i18n] = useTranslation('common');
 
 const tenantLabelPattern = /^[\p{L}\p{Z}\p{N}!'"@()&/\[\],\.\|-]+$/u;

 
 const language = useSelector((state) => state.app.language);

  const constraints = (t) => ({
        company: {
            presence: { allowEmpty: false, message: t('commons.validation.field.required') },
		    format: {
   		      pattern: tenantLabelPattern,
		    },            
            length: {
                minimum: 3, maximum: 30, message: t("onboardingStep1.form.company.invalidateLength")
            },
        },
        email: {
            presence: { allowEmpty: false, message: t('commons.validation.field.required') },
            format: {
                pattern: "(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|\"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\\\[\x01-\x09\x0b\x0c\x0e-\x7f])*\")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\\])",
                message: t("commons.validation.field.email"),
            },
        },
        phone: {
            presence: { allowEmpty: false, message: t('commons.validation.field.required') },
            length: {
                minimum: 8, maximum: 15, message: t("commons.validation.field.length")
            },
        },
        terms: {
            presence: { checked: false, message: t('commons.validation.field.required')}
        },
        captcha: {
            presence: { checked: false, message: t('commons.validation.field.required') }
        }
    });

 let schema = constraints(t);

 const basename = process.env.REACT_APP_BASENAME || null;

 const [formState, setFormState] = useState({
    isValid: false,
    values: {},
    touched: {},
    errors: {}
 });

 const [valueTerms, setValueTerms] = useState(true);
  
 const [hiddenPhone , setHiddenPhone] = useState(false);

 const phoneValidate = useSelector((state) => state.validatePhone.data);

 const emailValidate = useSelector((state) => state.validateEmail.data);

 const [appSumoAccount , setAppSumoAccount] = useState(false);

 useEffect(() => {
  if (phoneValidate) {
    setHelperPhone('');
    } else {
      setHelperPhone(t("onboardingStep1.form.phone.validatePhone"));
   }
  setFormState(formState => ({
   ...formState,
   isValid: phoneValidate
  }));
 }, [phoneValidate, language]);

 useEffect(() => {
  showEmailMessages();  
  const errors = validate(formState.values, schema, { fullMessages: false });
  setFormState(formState => ({
   ...formState,
   isValid: !errors && valueTerms && !emailValidate && phoneValidate,
   errors: errors || {}
   }));


 },[emailValidate, language ]);

 function showEmailMessages() {
  if (formState.touched['email'] === undefined || !emailValidate) {
    setHelperEmail('');
  } else {
    setHelperEmail(t("commons.validation.field.emailBussiness"));
  }
}

 useEffect(() => {
  const errors = validate(formState.values, schema, { fullMessages: false });
  setFormState(formState => ({
   ...formState,
   isValid: !errors && valueTerms && !emailValidate && phoneValidate,
   errors: errors || {}
   }));
 }, [formState.values, language]);

  useEffect(function () {
        const value = processUrl(queryParam, 'appSumoEmail');
        if (value) {
            const value2 = Buffer.from(value, 'base64').toString('ascii');
            setFormState(formState => ({
                ...formState,
                values: {
                    ...formState.values,
                    ['email']: value2,
                    ['phone']: '111111111111',
                }
            }));
            setHiddenPhone(true);
            setAppSumoAccount(true);
        }
    }, []);

  useEffect(() => {

    setFormState(formState => ({
      ...formState,
      values: {
        ...formState.values,
        ['captcha']: undefined,

      }
    }));

  }, [language]);

  const handleChange = event => {
    event.persist();

    setFormState(formState => ({
      ...formState,
      values: {
        ...formState.values,
        [event.target.name]:
          event.target.type === 'checkbox'
            ? event.target.checked
            : event.target.value
      },
      touched: {
        ...formState.touched,
        [event.target.name]: true
      }
    }));
    if( event.target.type === 'checkbox') {
        setValueTerms(event.target.checked);
      }
    if (event.target.name === 'email') {
      setHelperEmail('');
      setFormState(formState => ({
          ...formState,
        values: {
          ...formState.values,
          ['email']: event.target.value.toLowerCase(),
        },
        touched: {
          ...formState.touched,
          ['email']: true
        }
      }));
    }
  };

 const checkHandle = event => {
      setFormState(formState => ({
          ...formState,
          values: {
              ...formState.values,
              ['terms']: event.target.checked
          }
    }))
 }

  const handleRegister = event => {
    event.preventDefault();
    const { values } = formState
      const register = {
          locale: i18n.language,
          tenantLabel: values.company,
          tenantOwnerEmail: values.email,
          tenantOwnerPhoneNumber: values.phone,
          tenattId: 0,
          appSumoAccount
      };
    dispatch(registerAccount({ register: register, history, t: t}))
  };

  const handleChangeCaptcha = (value) => {
    setFormState(formState => ({
      ...formState,
      values: {
        ...formState.values,
        ['captcha']: value
      },
      touched: {
        ...formState.touched,
        ['captcha']: true
      }
    }));
  }

  const [helperPhone, setHelperPhone] = useState('');

  const [helperEmail, setHelperEmail] = useState('');

  const handleChangePhone = (value, data) => {
        setFormState(formState => ({
            ...formState,
            values: {
                ...formState.values,
                ['phone']: value,
                ['phoneCountryCode']: data
            },
            touched: {
                ...formState.touched,
                ['phone']: true
            }
        }));
    }

  const handleOnBlur = () => {
        if( formState.values.phone === '' ||formState.values.phone === undefined ){
            setHelperPhone(t('commons.validation.field.required'));
            setFormState(formState => ({
                ...formState,
                isValid: false
            }));
        } else if(formState.values.phone && formState.values.phone.length < 8 ) {
            setHelperPhone(t("onboardingStep1.form.phone.validateError"));
            setFormState(formState => ({
                ...formState,
                isValid: false
            }));
        }
        else {
            const data = {
                phoneNumber: formState.values.phone,
                countryCode: formState.values.phoneCountryCode.countryCode
            }
           setHelperPhone('');
           dispatch(validatePhone({ phoneData: data, history}));
        }
    };

  const handleOnBlurEmail = () => {
    if (!formState.values.email) {
      setFormState(formState => ({
        ...formState,
        isValid: false
      }));
    } else {
       showEmailMessages();
      const data = {
        email: formState.values.email
      }
      dispatch(validateEmail({ emailData: data, history }));
    }
  };
  const hasError = field => {
    return !!(formState.touched[field] && formState.errors[field]);
  }
  const hasErrorEmail = field => {
    return !!(formState.touched[field] && formState.errors[field]) || !!(emailValidate && formState.touched[field] );
  }

  const companyLabelValidador = (company, t) => {
	  
    if (company == '') {
		return t('commons.validation.field.required');
	} 
      
    const resultado = tenantLabelPattern.test(company);
  
    if (!resultado) {
	    return t("onboardingStep1.form.company.notMatch");
    }
    return ""; 
  }
  
  useGaTracker('onboarding-step1-tenant-data');
  useGa4Tracker('onboarding-step1-tenant-data');

  return (
    <Container component="main" maxWidth="lg" className="containerStep1">
      <Paper elevation={3} className={classes.paper2} >
        <div className={classes.paper}>
          <Typography component="h2" variant="h2" margin="normal" style={{ fontWeight: '700', textAlign: 'left', lineHeight: '40px' }}>
            {t('onboardingStep1.title')}
          </Typography>
          <Typography component="h1" variant="h3" margin="normal" style={{ marginTop: '30px', width: '100%', minWidth: '300px' }}>
            {t('onboardingStep1.subtitle')}
          </Typography>
          <div>
            <Alert severity="info" className={classes.info}>
              <strong> {t('onboardingStep1.information')}</strong>
            </Alert>
          </div>
          <form className={classes.form} onSubmit={handleRegister} >
            <TextField className={classes.textField} error={hasError('company')} fullWidth
              helperText={ hasError('company') ? companyLabelValidador(formState.values.company, t) : null }
              margin="normal"
              label={t('onboardingStep1.form.company.label')}
              name="company"
              onChange={handleChange}
              type="text"
              value={formState.values.company || ''}
              variant="outlined"
              inputProps={{
                maxlength: 30
              }}
              autoFocus
            />
            
            <TextField className={classes.textField} error={hasErrorEmail('email')} fullWidth
              helperText={hasError('email') ? formState.errors.email[0] : null}
              margin="normal"
              label={t('onboardingStep1.form.email.label')}
              name="email"
              onChange={handleChange}
              onBlur={() => {handleOnBlurEmail()}}
              type="email"
              value={formState.values.email || ''}
              variant="outlined"
              required={true}
              inputProps={{
                maxlength: 250,
                readOnly: hiddenPhone,
              }}
            />
            <FormHelperText className={classes.error}>{helperEmail}</FormHelperText>
            {!hiddenPhone && (
              <div>
                <PhoneInput style={{ marginTop: '20px', width: '100%', display: 'flex' }}
                  country={'us'}
                  value={formState.values.phone}
                  onChange={handleChangePhone}
                  specialLabel={t('onboardingStep1.form.phone.label')}
                  countryCodeEditable={false}
                  inputProps={{
                    name: 'phone',
                    required: true,
                    maxlength: 25
                  }}
                  isValid={helperPhone === '' && phoneValidate}
                  required={true}
                  onBlur={() => { handleOnBlur() }}
                />
                <FormHelperText className={classes.error}>{helperPhone}</FormHelperText>
              </div>)}

            <FormControlLabel style={{ marginTop: '20px' }}
              control={
                <Checkbox
                  checked={formState.values.terms || false}
                  onChange={handleChange}
                  name="terms"
                  color="primary"
                />
              }
              label={<Link
                color="inherit"
                href={`/account-onboarding/conditions-and-terms?lang=${i18n.language}`}
                className={classes.line1}
                target="_blank">
                <div className={classes.subtitle}>
                  {t('onboardingStep1.form.TOS')}
                </div>
              </Link>}
            />

            <div className="Register" style={{ marginTop: '10px' }}>
              <ReCAPTCHA
                sitekey={keyCaptcha}
                value={formState.values.captcha}
                name="captcha"
                onChange={handleChangeCaptcha}
                size={window.innerWidth < 590 ? "compact" : "normal"}
                hl={language} // Establece el idioma del Captcha según el idioma seleccionado
                key={language}
              />
            </div>

            <Button className={classes.submit} color="primary"
              fullWidth
              size="large"
              type="submit"
              variant="contained"
              disabled={!formState.isValid}>
              {t('onboardingStep1.form.button')}
            </Button>

          </form>
        </div>
      </Paper>
    </Container>
  );
};

OnboardingStep1.propTypes = {
  history: PropTypes.object,
  language: PropTypes.object
};
